import React from 'react';
import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import {
  IMenuCarmiData,
  IMenuCssVars,
  IMenuDefinition,
  IMenuProperties,
  MenuStyleProperties,
} from '../Menu.types';
import { orientationToCssVarsMap } from './utils/MapperUtils';

// TODO: replace with real data
const MenuMockProps = {
  slotToChildrenMap: {
    'a5e4f0ff-9f16-49ef-8816-9dc7634d008c': React.createElement('div', {
      content: `I'm a mega menu with a pink component`,
    }),
  },
};

export const props = withCompInfo<
  IMenuProperties,
  IMenuDefinition,
  IMenuCarmiData
>()(['compData'], ({ compData }, carmiData) => {
  return {
    ...carmiData,
    ...compData,
    ...MenuMockProps,
  };
});

export const css = withCompInfo<IMenuCssVars, IMenuDefinition>()(
  ['styleProperties'],
  ({ styleProperties }) => {
    const { orientation = 'horizontal' } =
      (styleProperties as MenuStyleProperties) ?? {};

    return {
      'min-width': 'min-content',
      ...orientationToCssVarsMap[orientation],
    };
  },
);

export default createComponentMapperModel({
  props,
  css,
});
